import { AxiosResponse } from 'axios'
import api from 'services/api'
import {
  RequestAnalysisMaterials,
  RequestAnalysisTotalizer,
  RequestApproveMaterial,
  RequestRejectMaterial,
  RequestAnalysisReport,
  QuotaMonthFilter
} from 'store/ExtraVolumeContext/Types/ExtraVolumeType'
import { AnalysisUploadReturn } from './interfaces'

export const getAnalysisTotalizer = async (params: RequestAnalysisTotalizer) => {
  const response = await api.post(`rascunho/v2/analise/totalizadores`, params)
  return response.data
}

export const getAnalysisMaterials = async (params: RequestAnalysisMaterials) => {
  const response = await api.post(`/rascunho/v2/analise/materiais`, params)
  return response.data
}

export const getRejectMotiveList = async () => {
  const response = await api.get(`/rascunho/v2/lista-motivo-reprovacao`)
  return response.data
}

export const getFilterQuotas = async (offices: QuotaMonthFilter) => {
  const params = new URLSearchParams()
  if (offices.length) {
    params.append('escritorios', offices.join(','))
  }

  const response = await api.get(`/rascunho/v2/volume-extra/meses-cota`, {
    params
  })

  return response.data
}

export const approveMaterials = async (params: RequestApproveMaterial[]) => {
  const response = await api.post(`/rascunho/v2/aprovacao-volume-extra`, params)
  return response.data
}

export const rejectMaterials = async (params: RequestRejectMaterial) => {
  const response = await api.post(`/rascunho/v2/reprovacao-volume-extra`, params)
  return response.data
}

export const fetchAnalysisReport = async (params: RequestAnalysisReport) => {
  const response: AxiosResponse<ArrayBuffer> = await api.post(
    '/rascunho/v2/exportar-historico-volume-extra',
    params,
    { responseType: 'arraybuffer' }
  )

  return response.data
}

export const fetchPendingAnalysisReport = async (params: RequestAnalysisTotalizer) => {
  const response: AxiosResponse<ArrayBuffer> = await api.post(
    '/rascunho/v2/exportar-analise-volume-extra',
    params,
    { responseType: 'arraybuffer' }
  )

  return response.data
}

export const uploadAnalysisFile = async (params: FormData) => {
  const response = await api.post<AnalysisUploadReturn>(
    `rascunho/v2/upload-planilha-volume-extra`,
    params,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )

  return response.data
}
